export const HEADER_BACKGROUND_COLOR = "#AED4EB";
export const PRIMARY_COLOR = "#2686C0";
export const SECONDARY_COLOR = "#AED4EB";
